import { useSimpleContext } from './index';
import { getAllReportDirec, getProjectInfo, getProjectByNo as getInoByNo } from '../../../assets/apis/innovate';
import { getProjectInfo as getSciPjt, getTecTopic, getSubject, getProjectByNo as getSciByNo } from '../../../assets/apis/scientist';
import { useUserData } from '../../../components/UserData';
import { get, set } from 'lodash';

import React, { useEffect } from 'react';
import { getS3Token, getConf, ProjectTypeEnums } from '../../../assets/apis/base';

export function useData() {
    const { state, update } = useSimpleContext((t) => [t.formType, t.loading, t.disabled, t.step, t.onSubmit]);
    const isView = state.isViewType;
    const projectNo = state.projectNo;
    const { sciProjectConfigId = 3, inoProjectConfigId = 4 } = useUserData();

    useEffect(function () {
        update((s) => (s.loading = true));
        getConf()
            .then((conf) => {
                const { timestamp, projectConfDto = [] } = conf || {};
                // 项目 id 可能变化，但是 type 不会变化
                const confSci = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.SciType);
                const confIno = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.InoType);
                Promise.all([
                    isView ? getProjectInfo({ projectNo }) : getProjectInfo({ projectConfigId: confIno?.id }),
                    isView ? getSciPjt({ projectNo }) : getSciPjt({ projectConfigId: confSci?.id }),
                    getS3Token(),
                    /** 处理无项目ID不触发请求 */
                    confSci?.id && getAllReportDirec({ projectConfigId: confSci.id }, 5),
                    confIno?.id && getAllReportDirec({ projectConfigId: confIno.id }, 6),
                    getSubject({ type: 1 }),
                    getSubject(),
                ])
                    .then(([innoValues, sciValues, token, sciDic, dic, subjects, sub2]) => {
                        update((t) => {
                            if (isView) {
                                t.disabled = true;
                            }
                            if (innoValues.status === 9) {
                                t.hasSubmit = true;
                                t.disabled = true;
                                t.submitType = 'innovate';
                                t.formType = 'innovate';
                            }
                            if (sciValues.status === 9) {
                                t.hasSubmit = true;
                                t.disabled = true;
                                t.submitType = 'scientist';
                                t.formType = 'scientist';
                            }
                            t.innovate.iniValues = getIniValuesIno(innoValues);
                            t.scientist.iniValues = getIniValuesSci(sciValues);
                            t.innovate.projectDict = dic?.reportDirectionList || [];
                            t.scientist.topics = sciDic?.directions || [];
                            t.scientist.subjects = subjects || [];
                            t.scientist.subjects2 = sub2 || [];
                            t.token = token;
                        });
                    })
                    .finally(() => {
                        update((t) => (t.loading = false));
                    });
            })
            .finally(() => {
                update((t) => (t.loading = false));
            });
    }, []);

    return { loading: state.loading };
}

export function useStep() {
    const { state, update } = useSimpleContext((t) => [t.step]);
    function setStep(newStep) {
        if (newStep !== state.step) {
            update((t) => {
                t.step = newStep;
            });
        }
        return Promise.resolve(true);
    }
    return { setStep, step: state.step };
}

function setDefault(obj, key, def) {
    const v = get(obj, key);
    set(obj, key, v || def);
}
function getIniValuesSci(values) {
    setDefault(values, 'personInfo.eduInfo', []);
    setDefault(values, 'personInfo.workInfo', []);
    setDefault(values, 'studyInfo.paper', []);
    setDefault(values, 'studyInfo.honor', []);
    setDefault(values, 'studyInfo.patent', []);
    setDefault(values, 'studyInfo.authScientist', []);
    setDefault(values, 'applyInfo.recommendInfo', []);
    return values;
}
function getIniValuesIno(values) {
    setDefault(values, 'additionInfo.propertyInfo', []);
    setDefault(values, 'additionInfo.honorInfo', []);
    setDefault(values, 'additionInfo.otherCredentials', []);
    setDefault(values, 'baseInfo.baseInfo', []);
    return values;
}
